export default __webpack_public_path__ + "static/media/support-allied-mario-ledesma.a4101cad.png";